import api from "api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { Link } from "react-router-dom";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import stateMap from "store/stateMap";
import "./style.scss";
import { PageCredential } from "component/PageCredential";
import {SurveyForm, SurveyBuilder} from "component/EditSurvey";
import { MaterialSymbol } from "react-material-symbols";
import fancybox, { popinfo } from "component/Fancybox/Fancybox";
import Sidebar from "component/Sidebar";
import { ComponentSurvey, ComponentSurveyRunner } from "component/Survey";
import ThreeDots from "component/ThreeDots";

const PageInitiativeInsideSurveyResponse = connect(stateMap)((props) => {
    const [activeSubPage, setActiveSubPage]         = useState('list');
    const [surveys, setSurveys]                     = useState({});
    const [surveyLoading, setSurveyLoading]         = useState(true);
    let navigate                                    = useNavigate();
    const { survey_id } = useParams();


    useEffect(() => {
        if(survey_id)
        {
            setSurveyLoading(true);

            api('/Survey', 'get', {
                id : survey_id
            }, 'Bearer ' + props.auth.token)
                .then(response => {
                    setSurveyLoading(false);
                    setSurveys(response.survey[0]);
                    // if(response.survey[0].Quota === 0 || response.survey[0].TotalResponse < response.survey[0].Quota)
                    // {
                    // }
                    // else
                    // {
                    //     setSurveys(false);
                    // }
                })
                .catch(err => {

                })
        }
    }, [survey_id])


    return (
        <div className="initiative-inside-survey container full-h">
            <PageCredential title={`${props.initiative.initiative.Title} | Survey`} />
            <div className="initiative-survey-response-container container ">
                <div className="max-w-800 mx-auto">
                    <Link to="../survey" className="btn btn-small"><MaterialSymbol icon="arrow_back_ios"/> Back</Link>
                    {
                        surveys?.SurveyID && <ComponentSurveyRunner surveyID={surveys.SurveyID} onComplete={answers => {
                            
                        }} />
                    }
                </div>
            </div>
        </div>
    )
})

export default PageInitiativeInsideSurveyResponse;